// extracted by mini-css-extract-plugin
export var modal = "_cv-0";